<template>
    <v-app style="margin-top:0px;" >
        <v-card flat v-bind:style="{ 'background-image': 'linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url(' + banner + ')' }" class="tst">
            <v-container>
                <h1 style="margin-top:20px;">{{ countryName }}</h1>
            </v-container>
        </v-card>
  <div class="container con" >
        <div class="row" style="margin-top:-100px; " >
          <div class="col-lg-9 col-md-9 col-sm-12" >
        <v-card flat style="border: 1px solid #b6b6b6;">
        <v-container>
            <div class="row" style="padding-top:20px;padding-left:15px;padding-right:15px;">
              <h2 class="country-heading m-2 " >WHY STUDY ABROAD IN {{ countryName }}</h2>
              <img :src="image" style="width: 50%;height:300px;" />
            <div class="col-lg-12 col-md-12 col-sm-12" style="color:grey;margin-top:50px;text-align: justify;">
              <h3 class="country-heading"><strong>Study in New Zealand</strong></h3>
              <p> We all know that New Zealand is a beautiful country, but there is much more to it than the picturesque scenery. It is emerging as one of the top preferences for Indian students who want to study abroad. New Zealand has an excellent education system, internationally accredited qualifications, extensive research opportunities and an unparalleled quality of life. When studying here, you can be sure of a welcoming and friendly society with an excellent support system for foreign students. If we see the geographical area New Zealand offers a wonderful multicultural environment that is in perfect harmony with the country's outdoor activities. New Zealand is full of all kinds of natural scenery, from snowy mountains and steaming volcanoes to rolling green hills, golden sandy beaches and lush rainforests. Living here will be an opportunity for every student to grow with its diverse culture and natural beauty at the same time. </p>
              <p><strong>Here are some of the top reasons why you should study in New Zealand.</strong></p>
              <ul>
                <li>Extensive learning and research opportunities</li>
                <li>A quality learning experience</li>
                <li>Globally recognized qualifications</li>
                <li>Simple eligibility criteria</li>
                <li>Culturally diverse place to live and study</li>
                <li>Enormous job opportunities post study.</li>

            </ul>
            <h3 class="country-heading"><strong>Study Process in New Zealand</strong></h3>
            <p>New Zealand has almost 50,000 international students per year out of a total  of over 150,000 applications, so it can be said that studying in New Zealand  is a good choice for international students. As a handful  of international students are offered admission,  they also apply for a study visa. Students who receive and accept an offer letter can apply for a student visa. The  processing time for New Zealand student visas varies between 8-10 weeks or may be longer depending on the number of applications  for a particular academic session. Check: New Zealand Student Visa Processing Time 
 Student visa applications can be applied for in four different ways - online, offline, through an immigration adviser or at a visa centre. The status of applications can be checked online through RealMe or NZeTA when applying online, while offline applications can be tracked through  immigration advisers and visas through VAC. International students are encouraged to apply for a visa as soon as they have confirmed their place at a New Zealand university. More details are as follows.</p>
 <h3 class="country-heading"><strong>New Zealand Student Visa Information :</strong></h3>
            <p>Students traveling to New Zealand to study for more than three months must apply for a New Zealand student visa. A student visa allows applicants to study full-time in New Zealand for a specified period of time. See the New Zealand International Student Guide. Student visas may have conditions that you must meet - for example, this may include but not be limited to: the name of the program you are allowed to study the name of the training provider the location of the service provider. In New Zealand and Requirement for Acceptable Insurance
New Zealand Student Visa Requirements to travel to New Zealand on a 
 Student Visa,</p>
              <p>An international student must meet the following criteria:</p>
              <p>The applicant must have a confirmed offer letter for a course registered with the New Zealand Department of Education or NZQA.</p>
              <p> Applicants must provide proof of INR 8, 00,000 for approximately one year to stay in New Zealand to study. </p>
              <p>Applicant must support NZD 1250 per month to survive in New Zealand.</p>
              <p> Ticket not to New Zealand, but to another place to show that the applicant really has enough expenses to study and live in New Zealand.</p>
              <p><strong>Documents required applying for New Zealand student visa</strong></p>
              <p><strong>New Zealand student visa applicants must have the following documents during the visa process: </strong></p>
              <p>Valid passport - passport must be valid for at least three months after the expiry date. </p>
            <ul>
               <li>Residency in New Zealand Completed student visa application (INZ 1012)</li>
               <li>Receipt of application payment (payment as above) Place offer - You must have a place offer from a New Zealand institute/university. Forms are usually issued upon receipt of tuition fees.</li>
               <li>Letter from your current institution confirming your status as a foreign student Health insurance receipt you may have to provide health and character to prove that your intention to stay in New Zealand is genuine Two passport-sized photographs.</li>
               <li>Transcripts, diplomas, degrees or certificates from your schools</li>
               <li>Test scores required by your college (such as TOEFL, GRE or GMAT scores) </li>
               <p><strong>New Zealand Student Visa Cost</strong></p>
               <p>New Zealand Visa Cost: Students who submit their student visa online will have to pay a visa fee of INR 330,7 7 (Approx) as Center Fees (New Delhi). Applicants applying for a student visa by post must pay Admission Center Fees (approx. USD 330,955) (New Delhi). Applicants should note that processing fees may vary depending on the visa center, so applicants should check the official website before applying for the exact amount. New Zealand student visa for Indians would cost around INR 2 ,000 to apply online.</p>
            </ul>

             <h4 class="country-heading"><strong>New Zealand Universities and Colleges</strong></h4>


            <div class="body table-responsive">
                      <table class="table table-bordered" style="margin-top: 10px;">
                          <thead>
                            <tr style="background-color: #f48d8d;">
                              <th style="text-align: center;">Sl No.</th>
                              <th>Universities</th>
                              <th style="text-align: center;">Ranking</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style="text-align: center;">1</td>
                              <td>Southern Institute of technologies</td>
                              <td style="text-align: center;"></td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">2</td>
                              <td>Auckland University of Technologies</td>
                              <td style="text-align: center;"></td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">3</td>
                              <td>Lincoln University</td>
                              <td style="text-align: center;">501-600</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">4</td>
                              <td>University of Canterbury</td>
                              <td style="text-align: center;">501-600</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">5</td>
                              <td>University of Waikato</td>
                              <td style="text-align: center;">401-500</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">6</td>
                              <td>Wellington Institute of Technologies</td>
                              <td style="text-align: center;"></td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">7</td>
                              <td>University of Otago</td>
                              <td style="text-align: center;">201-250</td>
                            </tr>
                          </tbody>
                        </table>
            </div>

      
            <h4 ><strong>Popular UG courses, required documents and fees in Europe:</strong></h4>
            <h4 ><strong>Documents required for UG course applications:</strong></h4>
               <p>1) Application Form</p>
               <p>2) 10th Mark sheet and Certificate –Notary attested</p>
               <p>3) 12th Mark sheet and Certificate- Notary attested</p>
               <p>4) Passport Copy – First and Last Page – Notary attested</p>
               <p>5) Letters of Recommendation – 2</p>
               <p>6) Statement of Purpose (Duly Signed by Student)</p>
               <p>7) Resume.</p>
               <p>8) IELTS or TOEFL score card if required–Notary attested</p>
               <p>9) Experience certificate – if any</p>
               <p>10) Birth Certificate</p>
               <p>11) Photograph</p>
 


            <div class="body table-responsive">
                      <table class="table table-bordered" style="margin-top: 10px;">
                          <thead>
                            <tr style="background-color: #f48d8d;">
                              <th>Popular Universities</th>
                              <th>Popular Courses</th>
                              <th>Fees Structure(Average Annual)</th>
                              <th>Exams</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>University of Otago</td>
                              <td>
                                <ul>
                                  <li>B.Tech</li>
                                  <li>MBBS</li>
                                  <li>B.Sc</li>
                                  <li>BBA</li>
                                  <li>MS</li>
                                  <li>MIM</li>
                                  <li>MBA/PGDM</li>
                                </ul>
                              </td>
                              <td>
                               
                                 17.09L-20.41L<br>
                                 19.62L<br>
                                 13.71L-20.29L<br>
                                 16.93L-19.88L<br>
                                 24.23 L - 27.72 L<br>
                                 24.23L-27.72L<br>
                                 32.94L<br>
                              
                              </td>
                              <td>IELTS,GRE,SAT,GMAT</td>
                            </tr>

                            <tr>
                              <td>University of Canterbury</td>
                              <td>
                                <ul>
                                  <li>B.Sc</li>
                                  <li>B.Tech</li>
                                  <li>BA</li>
                                  <li>B.Com</li>
                                  <li>MBA</li>
                                  <li>MEng</li>
                                </ul>
                              </td>
                              <td>
                              
                                  20.72 L - 31.15 L<br>
                                  40.65 L - 45.26 L<br>
                                  20.72 L - 34.79 L<br>
                             
                              </td>
                              <td>IELTS ,GRE,SAT,GMAT</td>
                            </tr>

                            <tr>
                              <td>University of Waikato</td>
                              <td>
                                <ul>
                                  <li>B.Tech</li>
                                  <li>B.Sc</li>
                                  <li>MS</li>
                                  <li>MBA</li>
                                  <li>MIM</li>
                                </ul>
                              </td>
                              <td>
                              
                                  15.05L<br>
                                  15.05L<br>
                                  14.45L-15.05L<br>
                             
                              </td>
                              <td>IELTS, GRE,SAT,GMAT</td>
                            </tr>

                            <tr>
                              <td>Lincoln University </td>
                              <td>
                                <ul>
                                  <li>B.Sc</li>
                                  <li>B.Agri</li>
                                  <li>BBA</li>
                                  <li>MS</li>
                                  <li>MIM</li>
                                  <li>M.Arch</li>

                                </ul>
                              </td>
                              <td>
                                12.95L-13.95L <br>
                                12.95L-14.7L <br>
                                12.95L-13.95L <br>
                              </td>
                              <td>IELTS, GRE,SAT,GMAT</td>
                            </tr>

                            <tr>
                              <td>University of Auckland</td>
                              <td>
                                <ul>
                                  <li>B.Sc</li>
                                  <li>MBBS</li>
                                  <li>B.Com</li>
                                  <li>MS</li>
                                  <li>MIM</li>
                                  <li>MEng</li>

                                </ul>
                              </td>
                              <td>
                                20.92 L - 30.89 L <br>
                                22.92 L - 29.89 L <br>
                                19.43 L - 28.9 L <br>
                                19.43 L - 20.92 L
                              </td>
                              <td>IELTS, GRE,SAT,GMAT</td>
                            </tr>

                            <tr>
                              <td>Auckland University of Technology</td>
                              <td>
                                <ul>
                              
                                  <li>B.Sc</li>
                                  <li>BBA</li>
                                  <li>BA</li>
                                </ul>
                              </td>
                              <td>
                                20.72 L - 34.79 L <br>
                                20.72 L - 31.15 L <br>
                                20.72 L - 27.95 L <br>
                              </td>
                              <td>GRE,SAT,GMAT,IELTS</td>
                            </tr>

                          </tbody>
                        </table>
            </div>

            <h4 class="country-heading"><strong>Visa Processes in New Zealand:</strong></h4>
              <p>Indian nationals must obtain a visa in order to access the magnificent country of New Zealand on a trip abroad. Let's examine the procedure for requesting a New Zealand visa.Call 022 4164 2214 for help with a New Zealand tourist visa.Indian nationals must obtain a visa in order to access the magnificent country of New Zealand on a trip abroad. Let's examine the procedure for requesting a New Zealand visa.</p>
        
            <h4><strong>Things to Keep in Mind</strong></h4>
            <p>You must present a passport that is at least three months valid from the intended date of your departure from New Zealand when you arrive in the country.</p>
            <p>You also need to have a current New Zealand visa stamped in your passport.</p>
            <p>You may go back and forth between India and New Zealand as often as you'd like up until the "expiration date of travel" if your visa allows multiple entries.</p>
            <p>With a standard tourist visa, you can only stay in New Zealand for a maximum of 9 months over the course of an 18-month period.</p>
            <p>A New Zealand visa cannot be renewed.</p>
            <p>If your visa runs out while</p>

            <h4><strong>Documents:</strong></h4>
             <p>You must submit the following paperwork when applying for a New Zealand visa:</p>
              <ul>
                  <li>Completed New Zealand Visitor Visa Application Form submitted by you (form number INZ 1017)</li>
                  <li>A passport that will still be valid three months after the anticipated departure date from New Zealand.</li>
                  <li>two passport-size, colored photos</li>
                  <li>A flight from New Zealand or evidence of sufficient means to purchase one.</li>
                  <li>Evidence of the money needed to live in New Zealand, which is NZD 1000 per month overall or NZD 400 per month if the rent has already been paid.</li>
                  <li>The Sponsorship Form is for Temporary Admission if you are supported by a resident.</li>
              </ul>

              <h4 ><strong>Steps</strong></h4>
              <p>You must adhere to the steps listed below in order to apply for the visa.</p>
              <ul>
                <li>From the internet, get the New Zealand Visiting Visa Application Form (form number INZ 1017).</li>
                <li>Completely and accurately fill out the form.</li>
                <li>Gather your photos and the pertinent supporting documentation.</li>
                <li>Make sure you are prepared to pay the application fee. Please be aware that cash payments for the fee are not accepted.</li>
                <li>Visit the nearby Visa Application Center and submit the application form along with the required supporting documentation, photos, and application fee.</li>
                <li>Once the visa has been finalized, you have the option of picking up your documents in person or having them delivered by courier to your home.</li>
                <li>Things to Keep in Mind.</li>

              </ul>

       <h4 class="country-heading"><strong>Employability in New Zealand:</strong></h4>
            <p>Graduates will discover that New Zealand can provide the ideal work-life balance because to its high quality of life, affordable cost of living, and variety of job options. It is never a bad time to hunt for work in New Zealand if you have the necessary qualifications and experience. With 3.2%, unemployment is low (February 2022).There are many career openings right now in fields like engineering, Technology, and medical, but there are also chances to contribute more interdisciplinary talents. Human resources (HR) and recruitment, manufacturing, transportation and logistics, trades and services, engineering, and community service and development have all recently experienced job growth. Many of New Zealand's businesses are small and medium-sized enterprises (SMEs), and even the nation's bigger companies are regarded as modest by international standards. Universities, IBM, and Air New Zealand are all well-liked employers of graduates.</p>
            <p>Before travelling to New Zealand, one must hunt for and accept a job in order to apply for a work visa. Online applications usually include a Resume and cover letter. In contrast to other countries, New Zealand uses CVs that explain your talents and give examples of how you've used them rather than listing all of your previous employment. A telephone interview may be granted if the application advances past the first hurdle. In-person interviews are typically informal and can be led by up to four participants. Before the interview, make sure you did a thorough investigation on the position and the business. Making relationships, networking, and speculatively applying for jobs can be helpful because many positions aren't officially published.</p>

            <h4 class="country-heading"><strong>Career scope in New Zealand:</strong></h4>
            <p> This list may be of interest to international job seekers who want to work in New Zealand. The advantages of working in New Zealand include the following:</p>
             
            <ul>
              <li>Superior Employability Here, 93% of students by chance find post-study work.</li>
              <li>Jobs that is available to overseas students only</li>
              <li>Exceptional work-life balance (New Zealand is ranked #1 globally).</li>
              <li>With at least 20+ days of guaranteed personal time and an extra 11 public holidays from work, the laid-back pace of living is reflected in high rankings for quality of life.</li>
              <li>In that they are removed from the bustle of the cities, jobs for Indian students in New Zealand are preferable to those back home.</li>
              <li>High ratings for the standard of living for foreigners.</li>
              <li>It's easy to commute when you have.</li>
         

            </ul>

 
             
            </div>     
          </div>
          </v-container>
      </v-card>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12">
            <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6;">
                    <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                        <h3>Interested in studying abroad?</h3>
                    </div>
                    <v-container v-if="otp==false">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout row wrap >
                                <v-flex xs12 style="padding-top:10px;" >
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" v-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-autocomplete
                                     outline 
                                     style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                     v-model="selectedCountry"
                                     :items="countries"
                                     color="primary"
                                     label="Preferred Country *"
                                     item-text="countryName"
                                     item-value="countryName"
  
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-autocomplete
                                     outline 
                                     style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                     v-model="selectedCourse"
                                     :items="courses"
                                     color="primary"
                                     label="Preferred Course *"
                                     item-text="courses"
                                     item-value="courses"
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;text-align:center;">
                                    <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
  
                    <v-container v-if="otp==true">
                        <v-form ref="form1" v-model="valid" lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <label>Enter Your OTP here *</label>
                                    <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;text-align:center;">
                                    <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
            </v-card>
            <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6; margin-top: 10px;">
              <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                        <h3>Universities</h3>
                    </div>
               <marquee direction="up" scrollamount="3" style="margin-top:20px;height:150px ; ">
                 <h5 style="margin-bottom:20px;color:#f12525" v-for="item in featuredUniversities" :key="item.id">{{ item.universityName }}</h5>
  
               </marquee>
            </v-card>
  
                <div class="">
                  <h2 class="m-4" >Global Study <span style="font-weight:600">Destinations</span></h2>
                </div>
              <v-card @click="onCountry(item)" v-for="item in countries" :key="item.id" elevation="10" :style="{backgroundImage: `url(${item.image})`}" class="tourtheme hvr mb-3">
                <div style="margin:0px;cursor: pointer; ">
                  <h4 class="mytxt" style="color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 125px;">{{ item.countryName }}</h4>
                </div>
              </v-card>
  
          </div>
        </div>
      </div>
        <v-dialog v-model="dialog" width="500px" persistent>
           <v-card>
             <div style="height:150px;background-color:green;text-align:center;">
               <div style="padding-top:25px;">
                  <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
               </div>
             </div>
             <v-container>
               <div style="text-align:center">
                   <h4>Thank You</h4>
                   <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                   <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
               </div>
             </v-container>
           </v-card>
       </v-dialog>
    </v-app>
  </template>
  
  <script>
  import config from "../../config.json";
  import moment from 'moment';
  export default {
    components: {
    },
    data() {
      return {
        tab: null,
        valid: true,
        btnSave: false,
        btnSave1: false,
        dialog: false,
        status: false,
        pin: 0,
        otp: false,
        name: [],
        featuredUniversities: [],
  
        ielts: true,
        toefl: false,
        gre: false,
        sat: false,
        gmat: false,
  
        details: null,
        image: null,
        banner: null,
        countryId: null,
        countryName: sessionStorage.getItem("countryName"),
  
        countries: [],
        selectedCountry: null,
  
        courses: [],
        selectedCourse: null,
  
        form: {
          name: null,
          email: null,
          mobileNumber: null
        },
        form1: {
          otp: null
        },
        emptyRule: [v => !!v || "Input is required"],
        rules: {
          required: value => !!value || "Required.",
          email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
          },
          mobileno: value => {
            const pattern = /^[1-9]{1}[0-9]{9}$/;
            return pattern.test(value) || "Mobile number not valid!!";
          },
        },
      };
      
    },
    
     mounted() {
      // this.axios
      //     .get(config.API + `country/author/${this.$route.params.id}`, {
      //       headers: {
      //         Authorization: "bearer " + sessionStorage.getItem("token")
      //       }
      //     })
      //     .then(res => {
      //       let _data = res.data.author;
      //       this.details = _data;
            
      //       if(_data.image!=null) {
      //         this.image = config.API + 'country/files1/' + _data.image;
      //       }
      //       if(_data.banner!=null) {
      //         this.banner = config.API + 'country/files2/' + _data.banner;
      //         console.log(this.banner);
      //       }
      //     })
      //     .catch(() => {
      //       this.$Progress.fail();
      //     });
  
        this.countryName = sessionStorage.getItem("countryName");
        this.image = sessionStorage.getItem("image");
        this.banner = sessionStorage.getItem("banner");
        this.countryId = sessionStorage.getItem("countryId");
          this.axios
        .get(config.API + `country/authors`, {
          headers: { Authorization: "Bearer " + sessionStorage.token }
        })
        .then(res => {
          let list = res.data.authors;
          console.log(list);
  
          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            if(element.id!=this.countryId) {
              this.countries.push({
              id: element.id,
              countryName: element.countryName.toUpperCase(),
              src: config.API1 + "country/files/" + element.src,
              image: config.API1 + "country/files1/" + element.image
              })
            }
          }
  
          console.log(this.countries);
        });

        this.axios
      .get(`https://api.worldwin.org/api/Levels`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data;
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          this.courses.push(element.levelName)
        }
      });
  
  
      this.axios
          .post(
            config.API + `university/search`,
            {
              countryId: this.countryId
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            let list = res.data.result;
            console.log(list);

            for (let index = 0; index < list.length; index++) {
              const element = list[index];
              
              this.featuredUniversities.push({
                id: element.id,
                universityName: element.universityName,
                src: config.API1 + "university/files/" + element.src
              })
            }
              })
          .catch(err => {
          });
     },
  
   methods: {
     blg(item) {
       sessionStorage.setItem("blogTitle", item.title);
       sessionStorage.setItem("blogDescription", item.description);
       sessionStorage.setItem("blogSrc", item.src);
       this.$router.push("/blogDetail/" + item.id );
     },
     getOtp() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'Country Details',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }

            let comment = "Preferred Country: " + this.selectedCountry + ", Preferred Course: " + this.selectedCourse;
            this.axios
          .post(
            `https://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              comment: comment,
              pageName: 'Country Details',
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: "Website",
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave = false;
          });
        }
        /* this.pin = Math.floor(1000 + Math.random() * 9000);
        this.axios
          .post(
            config.API + 'enquiry/otp',
            {
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              otp: this.pin
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.otp = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error("Mobile number already exists!!");
            this.btnSave = false;
          }); */
      /* } else {
        this.$toaster.error(`Required field are empty!!`);
      } */
    },
    onCountry(item) {
    sessionStorage.setItem("countryName", item.countryName);
    sessionStorage.setItem("image", item.image);
    sessionStorage.setItem("banner", item.banner);
    sessionStorage.setItem("countryId", item.id); 
    ////this.$router.push("/countrydetail/" + item.id );
    if(item.countryName=='UK') {
      this.$router.push("/study-in-uk");
    }
    else if(item.countryName=='DUBAI') {
      this.$router.push("/study-in-dubai");
    }
    else if(item.countryName=='SINGAPORE') {
      this.$router.push("/study-in-singapore");
    }
    else if(item.countryName=='USA') {
      this.$router.push("/study-in-usa");
    }
    else if(item.countryName=='AUSTRALIA') {
      this.$router.push("/study-in-australia");
    }
    else if(item.countryName=='CANADA') {
      this.$router.push("/study-in-canada");
    }
    
   },
  
      onSubmit() {
        if (this.$refs.form1.validate()) {
          if(this.pin == this.form1.otp) {
            this.btnSave1 = true;
          this.axios
            .post(
              config.API + `enquiry/author`,
              {
                name: this.form.name,
                email: this.form.email,
                mobileNumber: JSON.parse(this.form.mobileNumber),
                country: this.selectedCountry,
                course: this.selectedCourse,
                page: 'Test Preparation',
                date: moment().format('MMMM Do YYYY')
              },
              {
                headers: {
                  Authorization: "bearer " + sessionStorage.getItem("token")
                }
              }
            )
            .then(res => {
              console.log(res);
              this.name = this.form.name.split(' ');
              let firstName = this.name[0];
              let lastName = null;
  
              if(this.name.length > 2) {
                lastName = this.name[1] + this.name[2]
              }
              else {
                lastName = this.name[1]
              }
              this.axios
            .post(
              `http://api.worldwin.org/api/Leads1`,
              {
                firstName: firstName,
                lastName: lastName,
                mobileNumber: JSON.parse(this.form.subject),
                cmsId: JSON.parse(res.data.result.id),
                email: this.form.email,
                guardianName: null,
                guardianNo: 0,
                guardianEmail: null,
                relation: null,
                address: null,
                nature: null,
                source: null,
                document: false,
                documentType: null,
                notes: null,
                levelId: 0,
                leadDetails: null,
                leadTrainings: null
              },
              {
                headers: {
                  Authorization: "bearer " + localStorage.getItem("token")
                }
              }
            )
            .then(res => {
              this.dialog = true;
              this.btnSave1 = false;
            })
            .catch(() => {
              this.$toaster.error(`Mobile no is already registered`);
              this.btnSave = false;
            });
            })
            .catch(() => {
              this.$toaster.error("Mobile no is already registered");
              this.btnSave1 = false;
            });
          }
          else {
            this.$toaster.error("Please put a valied OTP");
          }
        } else {
          this.$toaster.error(`Required field are empty!!`);
        }
      },
  
      cancel() {
        this.form.name = null;
        this.form.email = null;
        this.form.mobileNumber = null;
        this.otp = false;
        this.dialog = false;
      },
   }
  };
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
  </style>
  
  <style scoped>
  .banner {
    background-image: url('https://www.pexels.com/photo/selective-focus-photo-of-man-using-laptop-1438081/');
    background-size: cover;
    height:200px;
  }
  .tst {
    border-radius:0px;
    height:300px;
    background-size: cover;
    color: white !important;
      
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
  .tourtheme {
    height: 190px;
    margin: 15px;
    background-size: 100%;
    transition: background-size 1s ease-in-out !important;
  }
  .tourtheme:hover {
    background-size: 120%;
  }
  .partner {
      margin-top: 15px;
      text-align: center;
      font-size: 23px;
      background-image: linear-gradient(to right, #f19a28 , #f12525);
      border-radius: 0px !important;
      color: whitesmoke !important;
  }
  .country-heading {
    color:#EC1616;
  }
  .country p {
    font-weight: 300;
    color:#666666;
    text-align: justify;
  }
  .v-card {
    padding: 10px;
    border-radius: 8px;
  }
  .v-sheet--offsets {
    top: -50px;
    position: relative;
  }
  .v-sheet--offset {
    top: -30px;
    position: relative;
  }
  .v-sheet--offsetf {
    top: -100px;
    position: relative;
  }
  .swo {
    box-shadow: none !important;
  }
  .opa {
    opacity: 1;
  }
  div.scroll { 
                  margin:4px, 4px; 
                  padding:4px; 
                  width: auto; 
                  height: 254px; 
                  overflow-x: hidden; 
                  overflow-x: auto; 
                  text-align:justify; 
              }
  
  .themecap {
    font-family: 'Open Sans', sans-serif;
    padding-top: 130px;
    color: white;
  }
  .top-left {
    font-family: 'Roboto Mono', monospace;
    font-size:40px ;
    padding-top: 200px;
    color: white;
    text-align: center;
  }
  .salont {
    font-family: 'Patua One', cursive;
  }
  .link:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .hvr:hover {
    cursor: pointer;
    border-radius: 5px !important;
    border : 1px solid;
    border-color: black !important;
    transition-duration: 0.7s;
    text-decoration: none !important;
  }
  .v-table tbody tr:not(:last-child) {
      border-bottom: none !important;
  }
  .con {
    margin-top: -100px;
    max-width: 1300px;
  }
  @media screen and (min-width: 768px){
    .con {
      margin-top: 0px!important;}
  
    }
  @media screen and (max-width: 768px) {
    .res {
      display: none;
    }
  }
  @media screen and (min-width: 768px){
    .man {
      display: none;
    }
  }
  img.center {
      display: block;
      margin: 0 auto;
  }
  .recent {
    font-family: 'Nanum Gothic', sans-serif;
  }
  .srch {
    position: absolute;
    z-index: 10;
    left: 16%;
    top: 0%;
  }
  .item {
      border:1px solid !important;
  }
  </style>
  